import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { Button, Form, FormGroup, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { CheckLg, DashCircle } from "react-bootstrap-icons";
import { addNewPos, getNextAccountCode } from "../store/api/DocumentsAPI";
import { setErrorDialog } from "../../store/api/CommonFunctions";
import { useRef } from "react";
const ModalAddNewPOS = (props) => {

    const [accCode, getAccCode] = useState({ Data: "" });
    const frm = useRef();
    const dispatch = useDispatch();
    const [pending, setPending] = useState(false);
    const { register, errors, handleSubmit } = useForm();
    const { popData, setPopData } = props;
    const { show } = popData;
    function close() {
        if (pending) {
            setPending(false);
        }
        setPopData({
            show: false
        })
    }
    function submit(data) {
        setPending(true);
        const onSuccess = (res) => {
            if (res.Data) {
                setPending(false);
                frm.current.reset();
                setErrorDialog(dispatch, "success", "ثبت کارتخوان");
                getNextAccountCode(3,"CashInTransit", getAccCode);
            }
            else if (res.Message) {
                setErrorDialog(dispatch, res.Message, "ثبت کارتخوان");
            }
        }
        addNewPos(data.Name, onSuccess);
    }
    useEffect(() => {
        if (show) {
            getNextAccountCode(3, "CashInTransit", getAccCode);
        }
    }, [show]);

    return (
        <Modal show={show} onHide={() => { }} size="sm">
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCreditCard} size="lg" />&nbsp;تعریف کارتخوان جدید
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form ref={frm} onSubmit={handleSubmit(submit)}>
                    <FormGroup className="mt-0">
                        <label>کد کارتخوان: </label><span style={{ color: "red" }}>*</span>
                        <Form.Control name="Code" ref={register({ required: true })} readOnly value={accCode?.Data ?? ""} />
                        {errors?.Code && <small className="errors">کد کارتخوان وارد نشده است</small>}
                    </FormGroup>
                    <FormGroup>
                        <label>نام کارتخوان: </label><span style={{ color: "red" }}>*</span>
                        <Form.Control name="Name" ref={register({ required: true })} defaultValue="کارتخوان " />
                        {errors?.Name && <small className="errors">نام کارتخوان وارد نشده است</small>}
                    </FormGroup>

                    <Button className="group-Btn mt-2" variant="success" type="submit" disabled={pending}><CheckLg />&nbsp;ثبت اطلاعات</Button>
                    <Button className="group-Btn mt-2" variant="danger" onClick={close}><DashCircle size={16} />&nbsp;انصراف &nbsp;</Button>
                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalAddNewPOS;